
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cutout-image",
      function () {
        return require("private-next-pages/cutout-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cutout-image"])
      });
    }
  